<template>
  <b-navbar variant="dark" type="dark" class="lockdown-navbar">
    <b-navbar-brand class="lockdown-navbar-brand">
      Lockdown Hacks
    </b-navbar-brand>
    <b-navbar-nav>
      <b-nav-text><a href="http://blog.nikhaldimann.com/2020/04/08/lockdown-hacks/" target="_blank">?</a></b-nav-text>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto" v-if="isAuthenticated">
      <b-nav-item-dropdown :text="authenticatedEmail" right>
        <b-dropdown-item :href="logoutUrl">Sign out</b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item v-on:click.prevent="deleteAccount">Delete account</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import buildUrl from 'build-url';
import { BDropdownDivider, BDropdownItem, BNavText, BNavbar, BNavbarBrand, BNavItemDropdown, BNavbarNav } from 'bootstrap-vue'
import { authenticatedEmail, isAuthenticated } from '../../libs/auth'
import GenericErrorMixin from '../../libs/generic_error_mixin'
import { jsonApi } from '../../libs/jsonapi'

export default {
  mixins: [GenericErrorMixin],
  data: function() {
    return {
      jsonApi: jsonApi,
      logoutUrl: buildUrl('/auth/logout', { queryParams: { origin: location.href }})
    };
  },
  computed: {
    authenticatedEmail,
    isAuthenticated
  },
  methods: {
    async deleteAccount() {
      const isConfirmed = await this.$bvModal.msgBoxConfirm(
        'Are you sure you want to delete your Lockdown Hacks account? '
        + 'This will delete all your data and we won\'t be able to recover it.',
        {
          okVariant: 'danger',
          okTitle: 'Yes, delete my account',
          cancelTitle: 'No, abort'
        }
      );
      if (!isConfirmed) {
        return;
      }

      try {
        await this.jsonApi.destroy('user', '');
        location.href = '/';
      } catch (error) {
        this.showGenericErrorModal();
      }
    }
  },
  components: {
    'b-dropdown-divider': BDropdownDivider,
    'b-dropdown-item': BDropdownItem,
    'b-nav-text': BNavText,
    'b-navbar': BNavbar,
    'b-navbar-brand': BNavbarBrand,
    'b-nav-item-dropdown': BNavItemDropdown,
    'b-navbar-nav': BNavbarNav,
  }
}
</script>

<style scoped>
.lockdown-navbar {
  padding: 0px;
  z-index: 1000;
  background-color: #343a40!important;
}
.lockdown-navbar-brand {
  padding-left: 0.5rem;
  font-size: 1rem;
}
</style>
